import app, { Component } from 'apprun';
import { serializeObject, api } from './api';

import { isValid, showSaveStatusMessage } from './utils';

export default class ddlEditComponent extends Component {

  state = { attributeValue: '', provStateCt: '' };
  // prettier-ignore
  view = (state) => {
    if (!state) {return;}

    return (
      <div>
        <form id="srNewForm" autocomplete="off">
          <div class="list-group-item">
            <label class="control-label">List: </label>&nbsp;
            <select id="attributeName" name="attributeName" required="required" data-validate>
              <option value=" ">Select</option>
              <option value="LanguagesSpoken">Languages</option>
              <option value="Designations">Professional Designations</option>
              <option value="Title">Titles</option>
              <option value="BusinessTypes">Specialties</option>
            </select>
            <div id="attributeNameErrMsg" class="text-danger"></div>
          </div>
          <div class="list-group">
            <div class="list-group-item">
              <label class="control-label">English Name: </label>&nbsp;
              <input id="attributeValue" name="attributeValue" class='pull-right' data-validate/>
              <div id="attributeValueErrMsg" class="text-danger"></div>
            </div>
            <div class="list-group-item">
              <label class="control-label">French Name: </label>&nbsp;
              <input id="attributeValueFR" name="attributeValueFR" class='pull-right' data-validate/>
              <div id="attributeValueFRErrMsg" class="text-danger"></div>
            </div>
          </div>
        </form>
        <div class="edit-buttons">
          <button class="btn btn-primary btn-xs pull-right" onclick={() => this.run('save')} >Save</button>
        </div>
        <div>
          <label class={(state.saveMsg!=='Success')?'text-danger':''}>{state.saveMsg}</label>&nbsp;
        </div>
      </div>
    );
  }

  update = {
    save: async (state) => {
      const formName = 'srNewForm';
      if (!isValid(formName)) {return;}
      const formData = serializeObject(document.getElementById(formName));
      try {
        const result = await api.invoke('POST', 'regionsserviced/AddLookupData', formData || {});
        state.saveMsg = 'Success';
        showSaveStatusMessage(result);
      } catch (ex) {
        state.saveMsg = await ex.json();
        showSaveStatusMessage();
      }

      return state;
    },

    cancel: (state) => {
      app.run('#clear-panel', state.panelId);
    }
  };
}
